import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './theme/main.css';
import Main from './page/main';
import reportWebVitals from './reportWebVitals';
import Questions from "./page/questions";
import { DataProvider } from "./data/store/dataProvider";
import Case from "./page/case";
import Redirect from "./ui/redirect";
import Login from "./page/login";
import BeforeYouGoPage from "./page/beforeYouGo";
import FeedbackPage from "./page/feedback";
import PhoneNumberPage from "./page/phoneNumber";
import FeedbackSentPage from "./page/feedbackSent";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DataProvider>
      <Router>
        <Routes>
          <Route path="/:companyId/question/:categoryId" element={<Questions />} />
          <Route path="/:companyId/question/:categoryId/beforeYouGo" element={<BeforeYouGoPage />} />
          <Route path="/:companyId/question/:categoryId/feedback" element={<FeedbackPage />} />
          <Route path="/:companyId/question/:categoryId/phoneNumber" element={<PhoneNumberPage />} />
          <Route path="/:companyId/question/:categoryId/feedbackSent" element={<FeedbackSentPage />} />
          <Route path="/:companyId" element={<Main />} />
          <Route path="/case" element={<Case />} />
          <Route path="/:companyId/login" element={<Login />} />
          <Route path="/" element={<Redirect to="https://www.easyllama.com/anonymous-reporting-tool/" />} />
        </Routes>
      </Router>
    </DataProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
